import { getBaseURL } from '@vue/store/helpers.js';
import axios from 'axios';
const ENDPOINT = '/api/offices';

export const getClosest = ({placeId}) => {
  return new Promise((resolve, reject) => {
    try {
      if(!placeId) {
        reject('offices API :: getClosest :: Invalid Form Params :', placeId);
        return false;
      }

      let requestURL = getBaseURL() + '/api/getClosestOffice';

      axios.post(requestURL, { placeId })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const getPosts = ({officeSlug}) => {
  return new Promise((resolve, reject) => {
    try {
      if(!officeSlug) {
        reject('offices API :: getPosts :: Invalid office slug :', officeSlug);
        return false;
      }

      let requestURL = getBaseURL() + `/api/education/office/${officeSlug}`;

      axios.get(requestURL)
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const getReviews = () => {
  return new Promise((resolve, reject) => {
    try {
      // if(!officeSlug) {
      //   reject('offices API :: getReviews :: Invalid office slug :', officeSlug);
      //   return false;
      // }

      let requestURL = getBaseURL() + '/reviews';

      axios.get(requestURL)
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};